module.exports = __webpack_public_path__ + "img/5c4907b.jpg";